module.exports = __webpack_public_path__ + "img/menu-boomhut.213e9596.png";